import React from "react";
import logo from "../assets/splash logo.svg";
import { FaFacebook, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { Link } from 'react-scroll'
import { Link as Links} from 'react-router-dom'

const Footer = () => {

  const handleClick =()=> {
    window.scrollTo({top: 0, behavior: 'smooth'})
  }
  return (
    <div className="bg-white w-full lg:h-[400px] flex lg:flex-row justify-evenly ms:flex-col border-t border-zinc-300 mt-auto">
      <div className="flex flex-col lg:items-start ms:items-center">
        <div className="flex flex-row lg:justify-start ms:items-center lg:mt-[38px] ms:mt-9">
          <img
            src={logo}
            alt=""
            className="lg:h-[50px] lg:w-[50px] ms:h-[30px] ms:w-[30px]"
          />
          <h1 className="uppercase text-center text-indigo-950 font-bold text-2xl">
            swop
          </h1>
        </div>
        <div className="lg:mt-[40px] lg:ml-0 ms:ml-[30px] lg:block ms:hidden">
          <div className="text-indigo-950 text-xl font-semibold">Get in touch</div>
          <div className="text-zinc-300 text-base font-normal break-all lg:w-auto ms:w-[250px] lg:mt-0 ms:mt-1">
            Feel free to get in touch with us through email
          </div>
          <div className="text-indigo-950 xl:text-[32px] font-semibold ms:mt-4 ms:text-[20px]">
            help@spaybusiness.com
          </div>
          <div className="flex flex-row justify-between w-[235px] mt-4">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="w-[25px] h-[25px] text-indigo-900" />
            </a>
            <a href="https://www.instagram.com/spaybusinesssolution/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="w-[25px] h-[25px] text-indigo-900" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter className="w-[25px] h-[25px] text-indigo-900" />
            </a>
            <a href="https://www.linkedin.com/company/spay-business-solutions-ltd/" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn className="w-[25px] h-[25px] text-indigo-900" />
            </a>
          </div>
          <div className="text-zinc-500 text-xs font-light mt-[28p text-indigo-900x] ms:mt-[16px]">
            SPay all rights reserved.
          </div>
          <div className="text-zinc-500 text-xs font-light ms:mb-[22px]">
            2023-2024
          </div>
        </div>
      </div>
      <div className="lg:flex lg:flex-row-reverse lg:mt-[130px]">
        <div className="flex lg:flex-row lg:justify-between lg:mt-0 ms:flex-col ms:ml-[30px] ms:mt-[50px] xl:w-[599px] lg:w-[430px]">
          <div className="flex flex-col">
            <div className="text-indigo-950 xl:text-[32px] font-semibold ms:text-[20px]">
              Company
            </div>
            <div className="flex flex-col mt-2">
            <Link 
            activeClass="active"
            to="home"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="cursor-pointer lg:text-[16px] text-zinc-500 ms:text-xs font-semibold mb-[10px]">
              Home
            </Link>
            <Link 
            activeClass="active"
            to="about"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="cursor-pointer lg:text-[16px] text-zinc-500 mt-2 ms:text-xs font-semibold mb-[10px]">
              About us
            </Link>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="text-indigo-950 xl:text-[32px] font-semibold ms:text-[20px]">
              Transparency
            </div>
            <div className="mt-2 flex flex-col">
              <Links onClick={handleClick} to={"/terms"} className="cursor-pointer text-zinc-500 lg:text-[16px] ms:text-xs font-semibold mb-[10px]">
                Terms and Conditions
              </Links>
              <Links onClick={handleClick} to={"/privacy"} className="cursor-pointer lg:text-[16px] mt-2 text-zinc-500 ms:text-xs font-semibold mb-[10px]">
                Privacy Policy
              </Links>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="text-indigo-950 xl:text-[32px] font-semibold ms:text-[20px]">
              Help
            </div>
            <div className="mt-2 flex flex-col">
              <Links onClick={handleClick} to={"/data"} className="cursor-pointer text-zinc-500 lg:text-[16px] ms:text-xs font-semibold mb-[10px]">
                Data deletion
              </Links>
              <Links onClick={handleClick} to={"/account"} className="cursor-pointer lg:text-[16px] mt-2 text-zinc-500 ms:text-xs font-semibold mb-[10px]">
                Account deletion
              </Links>
            </div>
          </div>
        </div>
        <div className="lg:mt-[40px] ms:mt-[20px] ms:ml-[30px] lg:hidden">
          <div className="text-indigo-950 lg:text-xl ms:text-base font-semibold">Get in touch</div>
          <div className="text-zinc-300 lg:text-base ms:text-sm font-normal break-all ms:w-[250px] ms:mt-1">
            Feel free to get in touch with us through email
          </div>
          <div className="text-indigo-950 lg:text-[32px] font-semibold ms:mt-4 ms:text-[20px]">
            help@spaybusiness.com
          </div>
          <div className="flex flex-row justify-between lg:w-[155px] ms:w-[110px] mt-4">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="lg:w-[19px] lg:h-[19px] ms:w-[13px] ms:h-[13px] text-indigo-900" />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="lg:w-[19px] lg:h-[19px] ms:w-[13px] ms:h-[13px] text-indigo-900" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter className="lg:w-[19px] lg:h-[19px] ms:w-[13px] ms:h-[13px] text-indigo-900" />
            </a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn className="lg:w-[19px] lg:h-[19px] ms:w-[13px] ms:h-[13px] text-indigo-900" />
            </a>
          </div>
          <div className="text-zinc-500 text-[12px] font-light lg:mt-[28px] ms:mt-[16px]">
            SPay all rights reserved.
          </div>
          <div className="text-zinc-500 text-[12px] font-light ms:mb-[22px]">
            2023-2024
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
